import { render, staticRenderFns } from "./invoice-record.vue?vue&type=template&id=f44387ce&scoped=true"
import script from "./invoice-record.vue?vue&type=script&lang=js"
export * from "./invoice-record.vue?vue&type=script&lang=js"
import style0 from "./invoice-record.vue?vue&type=style&index=0&id=f44387ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44387ce",
  null
  
)

export default component.exports